'use client';

import { useEffect, useState } from 'react';

const HydrationSafe = ({ children, fallback = null }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return fallback;
  }

  return (
    <div suppressHydrationWarning={true}>
      {children}
    </div>
  );
};

export default HydrationSafe; 